import { Injectable, Inject } from '@angular/core';
import { PRODUCT_SERVICE_KEYS, ProductSpecificService } from '@feature/product/services/product-specific.service';
import { UserSettingsService } from '@feature/user-settings/services/user-settings.service';

@Injectable({
  providedIn: 'root'
})
export class ProductSpecificServiceProvider  {

  constructor(
    @Inject(PRODUCT_SERVICE_KEYS) private productServices: ProductSpecificService[],
    private userSettingsService: UserSettingsService
  ) { }

  getServiceByProduct(product: string): ProductSpecificService {
    return this.productServices.find(x => x.product == product);
  }

  getService(): ProductSpecificService {
    const product = this.userSettingsService.getUserSettingsImmediate().Product;
    return this.productServices.find(x => x.product == product);
  }

}
